import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 35px;
  width: 100%;
  border-radius: 8px;
  text-transform: uppercase;
  font-weight: bold;
  color: var(--info);
  background: var(--info-transparent);
  position: relative;

  > button {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 50px;
    height: 20px;
    border-radius: 8px;
    background: var(--info);
    position: absolute;
    top: 8px;
    right: 20px;
    pointer-events: none;

    color: var(--white);
  }

  select {
    font-weight: bold;
    color: var(--info);
    font-size: 14px;
    padding: 10px 20px;
    outline: none;
    background: none;
    width: 100%;
    appearance: none;
    text-transform: uppercase;
    cursor: pointer;

    :disabled {
      opacity: 1;
      cursor: auto;
    }
  }
`;
